export const getModuleMessages = async (locale: string) => import(
    /* webpackChunkName: "wallet-module-locale-[request]" */ `@/modules/wallet/locales/${locale}.json`
);

export default getModuleMessages;
